import React from "react";
import { Theme, Paper } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";
import themeDark from "../../shared/themeDark";
import SMAButton from "../Button/Button";

interface ErrorTryAgainProps {
  label?: string | null | undefined;
  noBackground?: boolean | null | undefined;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: (theme: Theme) => ({
    display: "flex",
    backgroundColor: theme.palette.background.paper,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 0,
    boxShadow: "none",
    flex: "1 0 100%",
  }),
  reloadButton: {
    marginTop: "20px",
  },
}));

const ErrorTryAgain: React.FC<ErrorTryAgainProps> = (props) => {
  const classes = useStyles(themeDark);

  return (
    <Paper className={classes.root} style={props.noBackground ? { backgroundColor: "transparent" } : {}}>
      <Alert variant="outlined" severity="error">
        {props.label || "There was a network error. Please try again."}
      </Alert>
      <SMAButton variant="text" color="primary" className={classes.reloadButton} onAction={() => window.location.reload()}>
        Try again
      </SMAButton>
    </Paper>
  );
};

export default ErrorTryAgain;
